async function GetChoppers () {

    if (true) {

            let response;

            let params = {
                
              };

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "144", 
                    "parameters": params,
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "TrimChoppers", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);
    }
}
 
export default GetChoppers;